import { Layout } from '@/components/Common/Layout';
import { useAppContext } from '@/context/AppContext';
import clsx from 'clsx';
import { Button, Text } from 'ui/retail-ds';
import { useNavigate } from 'react-router-dom';
import { SadPumpkin } from 'ui/icons';
import { useEffect } from 'react';

const MaintenancePage = () => {
  const { isWebView } = useAppContext();

  useEffect(() => {
    window?.NativeBridge?.onLoadComplete?.();
  }, []);

  const navigate = useNavigate();

  const handleRedirect = () => {
    if (isWebView) {
      window.NativeBridge.onNativeClose();
    } else {
      navigate('/');
    }
  };

  return (
    <Layout.Main
      hideHeader
      className={clsx({
        '!max-w-[100vw] sm:!max-w-screen-sm sm:border border-retail-gray-50 bg-white lg:px-8 pb-40 pt-24':
          true,
        'select-none': isWebView,
      })}
      containerProps={{
        className: 'flex flex-col gap-7 h-full',
      }}
      footerProps={{
        isSticky: true,
        className: clsx({
          'h-fit': true,
          'select-none': isWebView,
        }),
        children: (
          <Button
            onClick={handleRedirect}
            intent="tertiary"
            className="max-w-full mt-1"
          >
            Return to home
          </Button>
        ),
      }}
    >
      <div className="flex flex-col items-center justify-center m-auto gap-2">
        <SadPumpkin className="w-[100px] h-[100px]" />
        <div className="flex flex-col items-center justify-center h-full gap-2 text-center">
          <Text variant="h4" className="!leading-[120%]">
            System upgrade in progress
          </Text>
          <Text
            variant="p3"
            className="text-retail-text-secondary !leading-[160%]"
          >
            We're performing a scheduled upgrade. This service will be
            unavailable from 23rd Dec, 11:30 AM to 8:00 PM.
          </Text>
        </div>
      </div>
    </Layout.Main>
  );
};

export default MaintenancePage;